export default __webpack_public_path__ + "static/media/icn_list_display.b7390359.svg";